import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner, Tab, Tabs } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import vindrApi from "../utils/vindrapi";
import schemas from "../data/dataSchemas";
import JSZip from 'jszip';
import fs from 'file-saver';
import globalContext from "../utils/globalContext";

//
//{
//
//    "name":"Latesto O\u00dc",
//    "airtableId":"rec4iQSTveeQTJnJD",
//    "email":"rein.palipea@latesto.ee",
//    "phone":"+3725045647",
//    "address":", ",
//    "id":233,
//    "properties":[
//        {
//            "id":"13402:002:0400",
//            "status":"Ready to sign"
//        }
//    ],
//    "totalArea":6.44
//
//}



export interface diagProps {
	owner: object;
	onClose: (value: string) => void;
}

const { Formik } = formik;

class DialogDownloadScenario extends React.Component {

	static contextType = globalContext;
	
	available = [
		'getPropertiesGeoJson',
		'getPropertiesCsv',
		'getLandownersCsv',
		'getBoundaryGeoJson',
		'getRoadsGeoJson',
		'getPowerLinesGeoJson',
		'getTurbinesGeoJson',
		'getScreenshot',
	];
	extensions = {
		'getPropertiesGeoJson': 'json',
		'getPropertiesCsv': 'csv',
		'getLandownersCsv': 'csv',
		'getBoundaryGeoJson': 'json',
		'getRoadsGeoJson': 'json',
		'getPowerLinesGeoJson': 'json',
		'getTurbinesGeoJson': 'json',
		'getScreenshot': 'png',
		'getProjectShapefile' : 'shp',
		'getProjectDXF': 'dxf',
		'getProjectOWS': 'ows',
		'getProjectGeojson':'json',
		'getProjectCsv': 'csv',
		'getProjectExcel': 'xlsx',
		'getProjectGeopackage' : 'gpkg'
	};

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

	handleSubmit(data){
		var self = this;
		

		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
		//const filesToDownload = data.layers.filter(value => this.available.includes(value));
		const filesToDownload = Array.isArray(data.format) ?  data.format : [data.format];

		const zip = new JSZip();
		
		var filePromises = [];
		
		filesToDownload.forEach((file)=>{
				filePromises.push(this.context.tc.draw[file](this.props.setup.scenario, this.context.getters.user));
		});
		
		Promise.all(filePromises).then((results)=>{
			results.forEach((f,k)=>{
				if(filesToDownload[k] == "getScreenshot"){
					zip.file([self.context.tc.draw.filenamify(self.context.getters.project.name)+'.png', f, {base64:true}]);
				}
				else {
					if(data.binary){
						//API returnes files already zipped
						fs.saveAs(f, self.context.tc.draw.filenamify(self.context.getters.project.name)+'.zip');
					}
					else {
						zip.file(...results[k]);
					}
				}
			});

			if(!data.binary){
				zip.generateAsync({ type: 'blob' }).then(function (content) {
					fs.saveAs(content, self.context.tc.draw.filenamify(self.context.getters.project.name)+'.zip');
				});
			}
			this.handleClose(filesToDownload);
		});
		
	};


	render() {
		return (
			<Modal size="md" show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} dialogClassName={(this.props.setup.stack ? 'stack' : '')} backdropClassName={(this.props.setup.stack ? 'stack' : '')} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Export data</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row className="px-3 download">
																
										
										
    <Tabs defaultActiveKey="project" id="uncontrolled-tab-example" className="mb-3">
		<Tab key={1} eventKey="project" title="Project data">
			
			
			<Formik onSubmit={(d)=>{this.handleSubmit(d);}} initialValues={{binary: true,format: 'getProjectShapefile',}}>	
				{({ handleSubmit, handleChange, touched, values, errors, setFieldValue }) => (
					<Form noValidate onSubmit={handleSubmit}>
						{this.state.status.sent === null ? (
							<>
								<div className="my-3">
									All project data including boundary, turbines, roads and powerlines.
									<br />
									CSV and Excel will only include the turbines.
								</div>
								Format:<br/>
								<Form.Select className="branded-select aw" onChange={(e) => setFieldValue("format", e.target.value)}>
									<option value="getProjectShapefile">Shapefile</option>
									<option value="getProjectDXF">DXF</option>
									<option value="getProjectOWS">OWS</option>
									<option value="getProjectGeojson">GeoJSON</option>
									<option value="getProjectCSV">CSV</option>
									<option value="getProjectExcel">Excel</option>
									<option value="getProjectGeopackage">Geopackage</option>
									
									
								</Form.Select>

								<Button variant="primary" type="submit">Export</Button>

							</>

							):(
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							)
						}
					</Form>
				)}	
			</Formik>
			
		</Tab>
		<Tab key={2} eventKey="property" title="Property data">
			<Formik onSubmit={(d)=>{this.handleSubmit(d);}} initialValues={{binary: false,format: 'getPropertiesGeoJson',}}>	
				{({ handleSubmit, handleChange, touched, values, errors, setFieldValue }) => (
					<Form noValidate onSubmit={handleSubmit}>
						{this.state.status.sent === null ? (
							<>
								<div className="my-3">All properties currently shown on the map</div>
								Format:<br/>
								<Form.Select className="branded-select aw" onChange={(e) => setFieldValue("format", e.target.value)}>
									<option value="getPropertiesGeoJson">GeoJSON</option>
									<option value="getPropertiesCsv">CSV</option>
								</Form.Select>

								<Button variant="primary" type="submit">Export</Button>

							</>

							):(
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							)
						}
					</Form>
				)}	
			</Formik>
		</Tab>
		<Tab key={3} eventKey="owners" title="Landowners">
			<Formik onSubmit={(d)=>{this.handleSubmit(d);}} initialValues={{binary: false,format: 'getLandownersCsv',}}>	
				{({ handleSubmit, handleChange, touched, values, errors, setFieldValue }) => (
					<Form noValidate onSubmit={handleSubmit}>
						{this.state.status.sent === null ? (
							<>
								<div className="my-3">All landowners currently in map in CSV format</div>
								Format:<br/>
								<Form.Select className="branded-select aw" onChange={(e) => setFieldValue("format", e.target.value)}>
									<option value="getLandownersCsv">CSV</option>
								</Form.Select>

								<Button variant="primary" type="submit">Export</Button>

							</>

							):(
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							)
						}
					</Form>
				)}	
			</Formik>
		</Tab>
    </Tabs>
										
										
										
						
										
										
										{/*
											<Form.Group as={Row} sm="12" controlId="validationFormik01">												
												<Form.Check type="switch" value="getTurbinesGeoJson" onChange={handleChange} name="layers" id="custom-switch1" label="Turbines"/>
												<Form.Check type="switch" value="getRoadsGeoJson" onChange={handleChange} name="layers" id="custom-switch2" label="Roads"/>
												<Form.Check type="switch" value="getPowerLinesGeoJson" onChange={handleChange} name="layers" id="custom-switch3" label="Power lines"/>
												<Form.Check type="switch" value="getPropertiesGeoJson" onChange={handleChange} name="layers" id="custom-switch4" label="Properties"/>
												<Form.Check type="switch" value="getPropertiesCsv" onChange={handleChange} name="layers" id="custom-switch8" label="Properties (CSV)"/>
												<Form.Check type="switch" value="getLandownersCsv" onChange={handleChange} name="layers" id="custom-switch9" label="Landowners (CSV)"/>
												<Form.Check type="switch" value="getBoundaryGeoJson" onChange={handleChange} name="layers" id="custom-switch5" label="Project boundary"/>
												<Form.Check type="switch" value="getScreenshot" onChange={handleChange} name="layers" id="custom-switch6" label="Map"/>
											</Form.Group>
											
											<div className="text-danger pt-2">
												{errors.layers}
											</div>
											*/}



					</Row>
				</Modal.Body>	
			</Modal>
		);
	}
}

export default DialogDownloadScenario;